import { render, staticRenderFns } from "./ReviewsTableOld.vue?vue&type=template&id=0166089c"
import script from "./ReviewsTableOld.vue?vue&type=script&lang=js"
export * from "./ReviewsTableOld.vue?vue&type=script&lang=js"
import style0 from "./ReviewsTableOld.vue?vue&type=style&index=0&id=0166089c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports